import { lighten } from 'polished';

export const exerciseColors = {
  1: '#E54D42',
  2: '#57D011',
  3: '#FB670E',
  4: '#E557FF',
  5: '#FFDA2B',
};

export function getDarkExerciseColors(color = 'rgb(51, 51, 51)') {
  return {
    1: lighten(0, color),
    2: lighten(0.15, color),
    3: lighten(0.3, color),
    4: lighten(0.45, color),
    5: lighten(0.6, color),
  };
}

const gymcloudColors = {
  // GymCloud's blue
  primary: '#0074d9',
  primaryBright: '#0074d9',

  // basic
  danger: '#FB670E',
  darkDanger: '#F53D3D',
  success: '#39CA74',
  link: '#0074D9',
  warning: '#ffac61',

  bgBlack: '#282d30',
  successLight: '#39CA74',
  avatarBgColor: '#cccccc',

  formLabel: '#0074d9',
  inputColor: '#495057',
  baseBanner: '#0074d9',
  modalHeader: '#0074d9',
  sidebarLink: '#0074D9',
  switchActive: '#35ce75',
  rbcEvent: '#0074D9',
  spinner: '#74c8f1',
  propertyColor: '#0074d9',
  goalButton: '#39ca74',

  workoutCreate: '#fb670e',
  programCreate: '#fb670e',
  commentCreate: '#e54d42',
  invitationAccepted: '#e557ff',
  exerciseResultCreate: '#ffda2b',

  tag: '#9ea0a1',

  bookmark: '#217ebe',
  bookmarkActive: '#ffc700',

  completed: '#39ca74',
  notCompleted: '#ec6e61',
  exerciseColors,
};

type Colors = typeof gymcloudColors & {
  baseExerciseColor?: string;
};

interface AppTheme {
  namespace: string;
  colors: Colors;
}

declare module 'styled-components' {
  export interface DefaultTheme {
    namespace: string;
    colors: Colors;
  }
}

export const configureTheme = (
  symbol: string,
  colors: Colors,
): AppTheme => ({
  namespace: symbol,
  colors:
    (symbol === 'gymcloud' && colors)
      ? gymcloudColors
      : {
        ...gymcloudColors,
        ...colors,
        primaryBright: colors.primary,
        exerciseColors: getDarkExerciseColors(
          colors.baseExerciseColor,
        ),
      },
});
